// hooks/usePublicProfile.ts

import { useQuery } from '@tanstack/react-query';
import { api } from 'api/v1/api';

export const getPublicProfile = async (userId: number) => {
  const res = await api.get(`/profiles/${userId}/public`);
  return res.data;
};

export const usePublicProfile = (userId?: number) => {
  return useQuery({
    queryKey: ['public-profile', userId],
    queryFn: () => getPublicProfile(userId as number),
    enabled: !!userId,
  });
};
